<div
  (click)="actionButtonText || cancelButtonText ? null : close()"
  *ngIf="visible"
  [@overlayAnimation]
  [ngClass]="{'with-background': showBackground}"
  class="feedback-overlay">

  <div (click)="$event.stopPropagation()" [ngClass]="type" class="feedback-content">

    <div *ngIf="showIcon" [@iconAnimation] class="icon-container">
      <mat-icon>{{ getIcon() }}</mat-icon>
    </div>

    <div *ngIf="message" class="message">{{ message }}</div>
    <div *ngIf="detailMessage" class="detail-message">{{ detailMessage }}</div>
    <a *ngIf="supportEmail" [href]="supportMailtoHref" class="support-link">{{ supportEmail }}</a>

    <!-- Action Buttons -->
    <div *ngIf="actionButtonText || cancelButtonText" class="action-buttons-container">
      <button
        *ngIf="actionButtonText"
        (click)="onActionButtonClick()"
        class="feedback-action-button retry-button"
        color="primary"
        mat-raised-button>
        {{ actionButtonText }}
      </button>
      <button
        *ngIf="cancelButtonText"
        (click)="onCancelButtonClick()"
        class="feedback-action-button cancel-button"
        mat-raised-button>
        {{ cancelButtonText }}
      </button>
    </div>
  </div>
</div>
